// removed by extract-text-webpack-plugin
module.exports = {"news":"_1WX4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homescreen/news/style.css
// module id = 356
// module chunks = 9